import {
  PracticeSetupStepCategory,
  PracticeSetupStepId,
} from '@principle-theorem/principle-core/interfaces';
import { Region } from '@principle-theorem/shared';
import { map } from 'rxjs/operators';
import { PracticeSetupStepValidation } from './practice-setup-step-validation';
import {
  IPageVisitTrackingConfig,
  IPracticeSetupStepDefinition,
} from './practice-setup-step.types';
import { initRawSchema, toParagraphContent } from '@principle-theorem/editor';

const pageVisitTracking: IPageVisitTrackingConfig = {
  routes: ['settings/practice/{practiceId}/integrations'],
  validationMode: 'any',
};

export const accMohSetupStep: IPracticeSetupStepDefinition = {
  id: PracticeSetupStepId.AccMohSetup,
  category: PracticeSetupStepCategory.AdditionalSettings,
  title: 'Configure ACC & MOH Settings',
  description: initRawSchema([
    toParagraphContent(
      `To use Principle's built-in MOH and ACC claiming systems, your practice credentials must first be configured on the Integrations page. Without these details in place, electronic claiming through either system will not be available.`
    ),
    toParagraphContent(
      `Both your MOH and ACC credentials are specific to each practice location. If you operate more than one practice, ensure the correct credentials are entered for each one individually.`
    ),
    toParagraphContent(
      `If you encounter any issues obtaining or uploading your credentials, contact your onboarding specialist for assistance before your go-live date to avoid any delays to your claiming workflow.`
    ),
  ]),
  dependsOn: [],
  getRoute: (_brand, practice) =>
    `settings/practice/${practice.ref.id}/integrations`,
  validate$: (practice$, step, options) => {
    return practice$.pipe(
      map((_practice) => {
        if (options?.reviewed || options?.skipped) {
          return { valid: true };
        }

        const pageVisitValidation =
          PracticeSetupStepValidation.validatePageVisits(
            step,
            pageVisitTracking
          );
        if (pageVisitValidation.valid) {
          return { valid: true };
        }

        return {
          valid: false,
          reason: 'Please review this page to complete this step',
        };
      })
    );
  },
  pageVisitTracking,
  regions: [Region.NewZealand],
};
